var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"text-right number",attrs:{"solo":"","flat":"","hide-details":"","background-color":"#00000000","dense":_vm.dense,"readonly":_vm.readonly,"suffix":_vm.suffix,"prefix":_vm.prefix},on:{"keyup":_vm.changeValue},model:{value:(_vm.tmpValue),callback:function ($$v) {_vm.tmpValue=$$v},expression:"tmpValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }